// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1L5bG","right":"Footer_right__32JeI","buttons":"Footer_buttons__jOpgI"};